import { createFileRoute } from '@tanstack/react-router';

import { requireOwnerOrAdmin } from '~/lib/route-auth';
import { CreateRoomPageComponent } from '~/page-components/create-room-page';

export const Route = createFileRoute('/rooms/new')({
  beforeLoad: async () => {
    await requireOwnerOrAdmin();
  },
  component: CreateRoomPageComponent
});
